import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, ArrowRight } from 'lucide-react';
export const DealerSupport = () => {
  return <div className="py-20 lg:py-24 bg-gray50 min-h-[calc(100vh-300px)]" data-id="element-501">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-502">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-503">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-504">
            For Registered Dealers
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-505">
            Dealer Support
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-506">
            We provide dedicated resources and support to help our registered
            dealers succeed, from quoting to final delivery.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16" data-id="element-507">
          <div className="bg-white p-8 rounded-xl border border-gray200 shadow-sm text-center" data-id="element-508">
            <div className="w-16 h-16 rounded-full bg-brandRed/10 flex items-center justify-center mx-auto mb-6" data-id="element-509">
              <Phone className="w-8 h-8 text-brandRed" data-id="element-510" />
            </div>
            <h3 className="text-xl font-bold text-ink mb-3" data-id="element-511">Dealer Hotline</h3>
            <p className="text-gray-600 mb-4" data-id="element-512">
              Direct access to our dealer support team.
            </p>
            <a href="tel:8886998511" className="text-brandRed font-bold text-lg hover:text-brandRedDark transition-colors" data-id="element-513">
              (888) 699-8511
            </a>
          </div>

          <div className="bg-white p-8 rounded-xl border border-gray200 shadow-sm text-center" data-id="element-514">
            <div className="w-16 h-16 rounded-full bg-brandRed/10 flex items-center justify-center mx-auto mb-6" data-id="element-515">
              <Mail className="w-8 h-8 text-brandRed" data-id="element-516" />
            </div>
            <h3 className="text-xl font-bold text-ink mb-3" data-id="element-517">Email Support</h3>
            <p className="text-gray-600 mb-4" data-id="element-518">
              Priority email response for active dealers.
            </p>
            <a href="mailto:dealers@customuniformsupplier.com" className="text-brandRed font-bold text-lg hover:text-brandRedDark transition-colors" data-id="element-519">
              dealers@customuniformsupplier.com
            </a>
          </div>
        </div>

        <div className="bg-ink rounded-2xl p-10 text-center text-white max-w-4xl mx-auto" data-id="element-520">
          <h2 className="text-2xl font-bold mb-4" data-id="element-521">
            Not a Registered Dealer Yet?
          </h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-522">
            Apply for wholesale access to unlock dedicated support,
            private-label production, and combined quantity pricing.
          </p>
          <Link to="/wholesale-apply" className="inline-flex items-center justify-center gap-2 bg-brandRed hover:bg-brandRedDark text-white font-bold py-3 px-8 rounded-sm transition-colors" data-id="element-523">
            Apply for Wholesale Access
            <ArrowRight className="w-5 h-5" data-id="element-524" />
          </Link>
        </div>
      </div>
    </div>;
};